import { CombinedGraphQLErrors } from '@apollo/client/errors'

// The API localizes the message, so the status is the only stable signal.
export function hasGraphQLErrorStatus(
  error: unknown,
  ...statusCodes: number[]
): boolean {
  return (
    CombinedGraphQLErrors.is(error) &&
    error.errors.some(({ extensions }) =>
      statusCodes.some(code => extensions?.['statusCode'] === code)
    )
  )
}
